import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { useStores } from '@/hooks/use-stores';

import MetricMonitorCustomGauge from './MetricMonitorCustomGauge';
import StationKPICustomGauge from './StationKPICustomGauge';
import PressureDropCustomGauge from './PressureDropCustomGauge';

const CustomGauges = observer(({ isCustomGaugesExpanded }) => {
  const { stationStore } = useStores();

  useEffect(() => {
    stationStore.getCustomMonitoredParameters();
  }, [stationStore.currentStation?.id]);

  const { customMonitoredParameters } = stationStore;

  const metricMonitors =
    customMonitoredParameters?.metricMonitors?.map(entity => {
      return {
        index: entity.index,
        element: <MetricMonitorCustomGauge entity={entity} key={entity.index} />,
      };
    }) ?? [];

  const stationKPIMonitors =
    customMonitoredParameters?.stationKPIMonitors?.map(entity => {
      return {
        index: entity.index,
        element: <StationKPICustomGauge entity={entity} key={entity.index} />,
      };
    }) ?? [];

  const pressureDropMonitors =
    customMonitoredParameters?.pressureDropMonitors?.map(entity => {
      return {
        index: entity.index,
        element: <PressureDropCustomGauge entity={entity} key={entity.index} />,
      };
    }) ?? [];

  const customMonitors = [...metricMonitors, ...stationKPIMonitors, ...pressureDropMonitors]
    .sort((a, b) => a.index - b.index)
    .map(entity => entity.element);

  return (
    <>
      {customMonitors.length > 0 && (
        <Container className={isCustomGaugesExpanded ? '' : 'collapsed'} $itemsLength={customMonitors.length}>
          {customMonitors}
        </Container>
      )}
    </>
  );
});

export default CustomGauges;

const Container = styled.div`
  gap: 9px;
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(120px, ${({ $itemsLength }: { $itemsLength: number }) => ($itemsLength > 4 ? '1fr' : '312px')})
  );
  margin: ${({ theme: { token } }) => token.marginXL}px 0 ${({ theme: { token } }) => token.marginMD}px 0;
  transition: height 0.15s ease-out, margin 0.15s ease-out;
  overflow: hidden;

  &.collapsed {
    height: 0;
    margin: 0;
  }
`;
